module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/fork-9be9e9e6fd58a33139cef2103955ecf4.svg";